import { render, staticRenderFns } from "./WorkPlan.vue?vue&type=template&id=f36f71bc&scoped=true"
import script from "./WorkPlan.vue?vue&type=script&lang=js"
export * from "./WorkPlan.vue?vue&type=script&lang=js"
import style0 from "./WorkPlan.vue?vue&type=style&index=0&id=f36f71bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36f71bc",
  null
  
)

export default component.exports